// extracted by mini-css-extract-plugin
export var banner = "_jz-0";
export var settingRow = "_jz-2";
export var titleIcon = "_jz-1";